<script lang="ts">
  import { onMount } from 'svelte';
  import { loadQueues } from '../../stores/lobby';
  import TournamentsTab from './TournamentsTab.svelte';
  import RankingTab from './RankingTab.svelte';
  import { activeLobbyTab } from '../../stores/uiState';

  onMount(() => {
    void loadQueues();
  });
</script>

<section class="lobby">
  <div class="tab-content">
    {#if $activeLobbyTab === 'ranking'}
      <RankingTab />
    {:else}
      <TournamentsTab />
    {/if}
  </div>

  <!-- Rodape decorativo — da um "chao" pro conteudo em vez do vazio
       escuro abaixo da lista. Puramente visual. -->
  <p class="lobby-tagline" aria-hidden="true">
    <span class="suit red">♥</span>
    <span class="suit">♠</span>
    truco 2v2 · paulista · torneios o dia todo
    <span class="suit">♣</span>
    <span class="suit red">♦</span>
  </p>
</section>

<style>
  .lobby {
    width: 100%;
    max-width: 720px;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .tab-content { min-height: 200px; }

  .lobby-tagline {
    margin: 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    color: var(--muted);
    user-select: none;
    white-space: nowrap;
  }
  .suit {
    font-size: 13px;
    color: rgba(180, 200, 240, 0.5);
  }
  .suit.red {
    color: rgba(255, 76, 126, 0.55);
  }

  @media (max-width: 480px) {
    .lobby-tagline { font-size: 8px; letter-spacing: 1.5px; gap: 6px; }
  }
</style>
